import { Button, Upload } from "antd"
import styles from "./index.module.scss"
import { useCallback, useMemo, useContext } from "react"
import Utils from '@utils/utils';
import SampleModal from '../SampleModal'
import { BATCH_IMAGES_TYPE } from '@utils/CONST';
import { AppContext } from '@utils/AppContext';


export default function UploadBox(props) {
    const { projectType, onUpload } = props
    const { globalUser } = useContext(AppContext)

    const uploadDebounce = useCallback(_.debounce(async (_, fileList) => {
        if (props.setUploadOpen) props.setUploadOpen(false) // 关闭追加商品弹窗
        onUpload(_, fileList)
    }, 100), [])
    const beforeUpload = async (file, fileList) => {
        console.log('===beforeUpload===')
        uploadDebounce(file, fileList)
        return false
    }
    const handleDrop = async (e) => {
        e.stopPropagation()
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList)
            return false
        }
    }

    const commodityType = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH || projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH
    }, [projectType])
    const UploadText = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '批量上传商品图' :
            projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '批量上传主商品图'
                : '批量上传模特图'
    }, [projectType])

    return (
        <div className={styles.Container}>
            <Upload.Dragger
                className={styles.Uploader}
                accept='image/jpeg,image/png,image/webp,image/avif'
                listType="picture-card"
                showUploadList={false}
                multiple
                beforeUpload={beforeUpload}
                onDrop={handleDrop}
            >
                <div className={styles.UploaderContent}>
                    <img src={"https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/" + (commodityType ? 'uploadCommidityIcon.png' : 'uploadModelIcon.png')} alt="" />
                    {projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? <span>将图片拖拽至此区域上传图片，仅支持上传透明背景PNG图
                        {/* <span
                            style={{ color: '#006EFF', textDecoration: 'underline', marginLeft: '8px' }}
                            onClick={(e) => {
                                e.stopPropagation()
                                navigate("/home/image_extraction")
                            }}
                        >去智能抠图处理</span> */}
                        </span> :
                        <span>将图片拖拽至此区域上传图片</span>}
                    <Button type="primary" className={styles.UploadBtn}>{UploadText}</Button>
                </div>
            </Upload.Dragger>
            <div className={styles.UploadTips}>
                <p>图片上传说明：</p>
                <p>一个项目最多上传{globalUser?.membership?.concurrentSku || 50}件商品，每张上传图视为一件商品，图片小于等于30M，分辨率不小于500*500px</p>
                <SampleModal showValue={projectType} />
            </div>
        </div>
    )
}